import { SxProps, Theme } from '@mui/material';
import { navbarSx } from 'modules/layout/styles';

const navLinkType: SxProps<Theme> = {
  typography: 'body1',
  fontWeight: 'fontWeightRegular'
};

const navbarStart: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 2,
  minWidth: 0
};

const separator: SxProps<Theme> = { color: 'customGrey.medium' };

const subAccountSelect: SxProps<Theme> = {
  ...navLinkType,
  width: 400,
  minWidth: 0,
  color: 'white',
  '&:before, &:hover:not(.Mui-disabled):before, &:after': {
    borderBottomColor: 'white'
  },
  '& .MuiSelect-icon': { color: 'white' }
};

const navLinks: SxProps<Theme> = { display: 'flex' };

const navLinkButton: SxProps<Theme> = {
  ...navbarSx.navLinkButton,
  ...navLinkType
};

const selectedNavLinkButton: SxProps<Theme> = {
  ...navbarSx.selectedNavLinkButton,
  ...navLinkType
};

const message: SxProps<Theme> = {
  minHeight: '100vh',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 2,
  px: 3,
  textAlign: 'center'
};

export const atsEmbedSx = {
  navbarStart,
  separator,
  subAccountSelect,
  navLinks,
  navLinkButton,
  selectedNavLinkButton,
  message
};
